import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchAllAdvertisement } from "../../service/AdService";
import { getCategoryPageLink } from "../../utils/advertisementAttachments";
import { apiUrl } from "../../config";

const ANNOUNCEMENT_CATEGORY = "Announcement";

const buildAnnouncementLines = (ad) => {
  const lines = [];

  [ad.address1, ad.address2, ad.address3, ad.address4]
    .filter(Boolean)
    .forEach((address) => lines.push(address));

  if (ad.location) {
    lines.push(ad.location);
  }

  [ad.phoneNo1, ad.phoneNo2, ad.phoneNo3]
    .filter(Boolean)
    .forEach((phone) => lines.push(phone));

  return lines;
};

const HomeAdvertisementCategoryCarousel = () => {
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    const loadSlides = async () => {
      try {
        const ads = await fetchAllAdvertisement();

        const announcementAds = (ads || []).filter(
          (ad) =>
            ad?.category?.toLowerCase() === ANNOUNCEMENT_CATEGORY.toLowerCase(),
        );

        const adSlides = announcementAds.map((ad) => ({
          key: `announcement-${ad.id}`,
          title: ad.title,
          lines: buildAnnouncementLines(ad),
          imageUrl: ad.imageUrl || null,
          externalLink: ad.webUrl || null,
          link: getCategoryPageLink(ANNOUNCEMENT_CATEGORY, "healthcare"),
          linkLabel: ad.webUrl ? "More Details" : "View Advertisements",
          bg: "linear-gradient(135deg, #00B3FF, #004274)",
        }));

        setSlides(adSlides);
      } catch (error) {
        console.error("Failed to load announcement carousel:", error);
        setSlides([]);
      }
    };

    loadSlides();
  }, []);

  if (slides.length === 0) {
    return null;
  }

  return (
    <div className="banner-main-wrapper2 float_left home-ad-category-carousel">
      <div
        id="homeAdCategoryCarousel"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">
          {slides.map((slide, index) => (
            <div
              key={slide.key}
              className={`carousel-item${index === 0 ? " active" : ""}`}
            >
              <div
                className="home-ad-category-slide d-flex flex-column flex-md-row align-items-center justify-content-center gap-4 px-3 py-4"
                style={{
                  background: slide.bg,
                  minHeight: "320px",
                }}
              >
                {slide.imageUrl && (
                  <img
                    src={`${apiUrl}/${slide.imageUrl}`}
                    alt={slide.title}
                    className="shadow"
                    style={{
                      width: "220px",
                      height: "220px",
                      objectFit: "cover",
                      borderRadius: "12px",
                      border: "3px solid #fff",
                    }}
                  />
                )}

                <div className="text-white text-center text-md-start">
                  <h3 className="fw-bold mb-1">{slide.title}</h3>
                  <p className="mb-3 opacity-75">{ANNOUNCEMENT_CATEGORY}</p>
                  <div className="home-ad-announcement-list">
                    {slide.lines.map((line, lineIndex) => (
                      <div key={`${slide.key}-line-${lineIndex}`}>{line}</div>
                    ))}
                  </div>
                  {slide.externalLink ? (
                    <a
                      href={slide.externalLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="page2-btn bg-change fw-bold mt-3 d-inline-block"
                    >
                      {slide.linkLabel}
                    </a>
                  ) : (
                    <Link
                      to={slide.link}
                      className="page2-btn bg-change fw-bold mt-3 d-inline-block"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      {slide.linkLabel}
                    </Link>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#homeAdCategoryCarousel"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#homeAdCategoryCarousel"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};

export default HomeAdvertisementCategoryCarousel;
